
import Vue from 'vue'
import Filters from './Filters.vue'

interface FilterWithSearchData {}

interface FilterWithSearchMethods {
	search(): void
	toggleFilter(): void
	addQuery(event: Event): void
	handleClickOutside(event: any): void
	setSearchHeight(): void
}

interface FilterWithSearchComputed {
	query: string
	showFilter: boolean
}

interface FilterWithSearchProps {}

export default Vue.extend<FilterWithSearchData, FilterWithSearchMethods, FilterWithSearchComputed, FilterWithSearchProps>({
	name: 'Search',
	mounted() {
		this.setSearchHeight();
		
		window.addEventListener("resize", this.setSearchHeight)
		document.addEventListener("click", this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.handleClickOutside);
	},
	computed: {
		query() {
			return this.$store.getters.query
		},
		showFilter() {
			return this.$store.state.showFilter
		},
	},
	methods: {
		search() {
			this.$store.dispatch({
				type: 'search',
				payload: true
			})
			this.$store.commit({
				type: 'showSearchHits',
				payload: null
			})
		},
		toggleFilter() {
			this.$store.dispatch({
				type: 'setFilterModal',
				payload: this.$store.getters.showFilter
			})
		},
		addQuery(event) {
			const target = event.target as HTMLInputElement
			this.$store.commit({
				type: 'setQuery',
				payload: target.value
			})
		},
		handleClickOutside(event) {
            if (this.$refs.search && !(this.$refs.search as HTMLElement).contains(event.target)) {
                this.$store.dispatch({
				    type: 'removeFilterModal',
				    payload: true
			    })
            }
        },
		setSearchHeight() {
			const search = this.$refs.search as HTMLElement;
			const searchHeight = search ? search.clientHeight / 2 : 0;
			search && searchHeight && search.setAttribute("style", `margin-top:-${searchHeight}px`);
		}
	},
	components: {
		Filters
	}
})
